import wrappedFetch from 'common/api/base';

export const fetchStaticIpPlans = async () => {
  return wrappedFetch('/static_ip_plans.json').then((response) => response.json());
};

export const getUserStaticIpDetails = async (broker: string) => {
  return wrappedFetch(`/user_static_ip_details.json?broker=${broker}`, {
    method: 'GET',
  }).then((response) => response.json());
};

export const giftStaticIp = async () => {
  return wrappedFetch(`/gift_static_ip.json?static_ip_plan_id=1`).then((response) => response.json());
};
